//import React from "react";
import * as ReactDOM from 'react-dom/client';
import App from "./App"; // ts-loader and typescript modules needed!

import "../../i18n/i18n.config";
//import i18next from "../../i18n/i18n.config";

const container = document.getElementById('rd');
const root = ReactDOM.createRoot(container);
document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.tab-toggle');
    var tabs = document.getElementById('tab-nav');

    if (!toggle || !tabs) return;

    toggle.addEventListener('click', function () {
        var isOpen = tabs.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
});
root.render(<App />);